export const walker = (tree: any[], cb: any, depth = 1, key = "children") => {
  return tree.map((leaf) => {
    if (leaf && leaf[key] && leaf[key].length > 0) {
      leaf[key] = walker(leaf[key], cb, depth + 1, key);
    }
    return cb(leaf, depth);
  });
};
